import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const useRadiologyHL7OrderDetails = (orderId, { enabled = true } = {}) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["RadiologyHL7Details", orderId, tenantVal],
    queryFn: async () => {
      if (!orderId || !tenantVal) return null;
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/healthlink/common/results/details/${orderId}`
      );

      return response.data;
    },
    enabled: enabled && !!orderId && !!tenantVal,
    meta: { errorMessage: "Error fetching radiology HL7 details" },
  });
};

export { useRadiologyHL7OrderDetails };